
import { defineComponent } from "vue";

export default defineComponent({
  props: {
    label: {
      type: String,
      required: true
    },
    type: {
      type: String,
      default: "default" // 'default', 'red', 'green', 'enroll', 'attendance', 'content'
    },
    disabled: {
      type: Boolean,
      default: false
    },
    onClick: {
      type: Function,
      default: null
    }
  },
  computed: {
    buttonClass(): string {
      switch (this.type) {
        case "red":
          return "red";
        case "green":
          return "green";
        case "enroll":
          return "enroll hover-style";
        case "attendance":
          return "attendance hover-style";
        case "content":
          return "content hover-style";
        default:
          return "";
      }
    }
  },
  methods: {
    handleClick() {
      if (!this.disabled && this.onClick) {
        this.onClick();
      }
    }
  }
});
